var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('div',{staticClass:"error-page__content"},[_c('h1',{staticClass:"error-page__title"},[_vm._v("404")]),_c('p',[_vm._v("Désolé, la page que vous recherchez n'existe pas.")]),_c('a',{staticClass:"btn base-button btn-default",attrs:{"href":"/","role":"button"}},[_c('span',[_vm._v("Retour au tableau de bord")])])])])
}]

export { render, staticRenderFns }